import type { Text } from "pixi.js";

export interface TextFitBox {
  width: number;
  height: number;
}

/**
 * `Label.overflow = SHRINK` over a fixed `contentSize`: scale the text DOWN (never up) so its
 * unscaled measure fits the box. Call again after every text change (`LocalizedText` does).
 */
export function fitTextToBox(text: Text, box: TextFitBox): void {
  const bounds = text.getLocalBounds();
  const scale = Math.min(1, box.width / Math.max(1, bounds.width), box.height / Math.max(1, bounds.height));
  text.scale.set(scale, scale);
}
